import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MoneyRoutingModule } from './money-routing.module';
import { MoneyActionSelectComponent } from 'src/app/pages/money/money-and-transactions/money-and-transactions.component';
import { MoneyDepositEditComponent } from 'src/app/pages/money/money-deposit-edit/money-deposit-edit.component';
import { MoneyDepositListComponent } from 'src/app/pages/money/money-deposit-list/money-deposit-list.component';
import { MoneyWithdrawComponent } from 'src/app/pages/money/money-withdraw/money-withdraw.component';
import { MoneyDropdownSelectComponent } from 'src/app/shared/money-dropdown-select/money-dropdown-select.component';
import { MoneyAmountInputComponent } from 'src/app/shared/money-amount-input/money-amount-input.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { PricePipeModule } from 'src/app/pipes/price.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { TooltipButtonModule } from 'src/app/shared/tooltip-button/tooltip-button.module';
import { DepositInvestmentButtonComponent } from 'src/app/shared/deposit-investment-button/deposit-investment-button.component';
import { PlusMinusInputModule } from 'src/app/shared/plus-minus-input/plus-minus-input.module';
import { RadioInputGroupModule } from 'src/app/shared/radio-input-group/radio-input-group.module';
import { TextInputModule } from 'src/app/shared/text-input/text-input.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DropdownModule } from 'src/app/shared/dropdown/dropdown.module';
import { FilterableTransactionsModule } from '../filterable-transactions/filterable-transactions.module';
import { MoneyRentComponent } from 'src/app/pages/money/money-rent/money-rent.component';
import { RentWithdrawalCardComponent } from 'src/app/pages/money/money-rent/rent-withdrawal-card/rent-withdrawal-card.component';
import { SwiperModule } from 'swiper/angular';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { RentWithdrawalDraftCardComponent } from 'src/app/pages/money/money-rent/rent-withdrawal-draft-card/rent-withdrawal-draft-card.component';

@NgModule({
  declarations: [
    MoneyActionSelectComponent,
    MoneyDepositListComponent,
    MoneyDepositEditComponent,
    MoneyWithdrawComponent,
    MoneyAmountInputComponent,
    MoneyDropdownSelectComponent,
    DepositInvestmentButtonComponent,
    MoneyRentComponent,
    RentWithdrawalCardComponent,
    RentWithdrawalDraftCardComponent,
  ],
  imports: [
    CommonModule,
    MoneyRoutingModule,
    TranslateModule,
    PricePipeModule,
    AngularSvgIconModule,
    FormsModule,
    ButtonModule,
    PreloadSpinnerModule,
    TooltipButtonModule,
    PlusMinusInputModule,
    RadioInputGroupModule,
    TextInputModule,
    NgxPaginationModule,
    DropdownModule,
    FilterableTransactionsModule,
    SwiperModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  exports: [
    MoneyActionSelectComponent,
    MoneyDepositListComponent,
    MoneyDepositEditComponent,
    MoneyWithdrawComponent,
    MoneyRentComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class MoneyModule { }
